import { gameplayConfig, type SkinId, type UpgradeId } from "./gameplay-config";

const upgradeMaxLevels = {
  "food-value": 4,
  "movement-speed": 4,
  "starting-size": 4,
} as const satisfies Readonly<Record<UpgradeId, number>>;

export const progressConfig: {
  readonly defaultSkinId: SkinId;
  readonly maximumDailyChallengeRecords: 64;
  readonly maximumSettledRoundReceipts: 256;
  readonly schemaVersion: 3;
  readonly skinIds: readonly SkinId[];
  readonly storageKey: "snakely:progress";
  readonly upgradeMaxLevels: Readonly<Record<UpgradeId, number>>;
} = {
  defaultSkinId: gameplayConfig.defaultSkinId,
  maximumDailyChallengeRecords: 64,
  maximumSettledRoundReceipts: 256,
  schemaVersion: 3,
  skinIds: gameplayConfig.skins.map((skin) => skin.id),
  storageKey: "snakely:progress",
  upgradeMaxLevels,
};
